import { MemberProfile } from './member-profile'
import { MemberProfileSection } from './member-profile-section';

export class UpdateMemberProfileRequest {
    public member: MemberProfile;
    public updateSections: Array<MemberProfileSection>;
}